@switch (columnName) {
  @case ('department') {
    {{ element.department?.name || emptyValue }}
  }
  @case ('shiftName') {
    {{ element.shiftName || emptyValue }}
  }
  @case ('from') {
    <div class="text-icon-container">
      {{ element.from | date: dateTimeFormat }}
      @if (showConflictIcon) {
        <mat-icon
          class="warn"
          [matTooltip]="conflictTooltip.key | translate: conflictTooltip.params"
        >
          warning
        </mat-icon>
      }
    </div>
  }
  @case ('to') {
    @if (element.isInfiniteEndDate) {
      {{ 'ongoing' | translate }}
    } @else {
      {{ element.to | date: dateTimeFormat }}
    }
  }
  @case ('periodInDays') {
    @if (element.periodInDays == null) {
      {{ emptyValue }}
    } @else {
      {{ element.periodInDays }} {{ 'days' | translate }}
    }
  }
  @case ('activityName') {
    @if (activityColor) {
      <app-ui-activity-color
        [color]="activityColor"
        [label]="element.activityName"
      ></app-ui-activity-color>
    } @else {
      {{ element.activityName }}
    }
  }
  @case ('tripName') {
    {{ hasTrip && element.tripName ? element.tripName : emptyValue }}
  }
  @case ('tripStatus') {
    @if (hasTrip && tripStatusKey) {
      <app-ui-pill [name]="tripStatusKey" [customLabel]="true">
        {{ tripStatusKey | translate }}
      </app-ui-pill>
    } @else {
      {{ emptyValue }}
    }
  }
  @case ('status') {
    {{ statusKey | translate }}
  }
  @default {
    <app-default-cell [columnName]="columnName" [element]="element"></app-default-cell>
  }
}
